interface CardData {
  index: string;
  title: string;
  description: string;
}

const cards: CardData[] = [
  {
    index: "01",
    title: "Προσομοιώσεις & Διαγωνίσματα",
    description:
      "Εβδομαδιαία προγραμματισμένα διαγωνίσματα και τρεις πλήρεις προσομοιώσεις κάθε χρόνο, με στατιστικό προφίλ και σύγκριση βαθμολογιών από όλη την επικράτεια.",
  },
  {
    index: "02",
    title: "Αναγνωστήριο",
    description:
      "Διαμορφωμένες αίθουσες για μελέτη και επίλυση ασκήσεων μετά το μάθημα, με τη βοήθεια των καθηγητών πάντα δίπλα στους μαθητές.",
  },
  {
    index: "03",
    title: "Ολιγομελή τμήματα & Ιδιαίτερα",
    description:
      "Ολιγομελή τμήματα και δυνατότητα ιδιαίτερων μαθημάτων, καθώς και κλειστά τμήματα δύο ή τριών ατόμων προσαρμοσμένα στο μαθησιακό προφίλ κάθε μαθητή.",
  },
  {
    index: "04",
    title: "Ευελιξία στη διδασκαλία",
    description:
      "Επιλέξτε παρακολούθηση online ή δια ζώσης, χωρίς εκπτώσεις στην ποιότητα του μαθήματος, με πλήρη καθοδήγηση και άμεση επαφή με τους καθηγητές.",
  },
];

export default function Why() {
  return (
    <section className="sec why" id="why">
      <div className="wrap">
        <div className="sec-head">
          <p className="eyebrow">Γιατί Πράξη</p>
          <h2>Όλα όσα χρειάζεται ένας μαθητής, σε έναν χώρο.</h2>
          <p>
            Πολύ περισσότερα από ένα απλό μάθημα — μια ολοκληρωμένη υποστήριξη
            που κάνει τη διαφορά.
          </p>
        </div>
        <div className="card-grid">
          {cards.map((card) => (
            <article className="card" key={card.index}>
              <span className="bar" aria-hidden="true"></span>
              <div className="ix">{card.index}</div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
